import { render, staticRenderFns } from "./CockpitMatryoshkaItemAuditTab.vue?vue&type=template&id=539ada21&scoped=true"
import script from "./CockpitMatryoshkaItemAuditTab.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemAuditTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ada21",
  null
  
)

export default component.exports